export enum ShopIntegrationType {
  RosaOne = 'rosa_one',
  SQ = 'sq',
  BF = 'bf',
}
